import axios from 'axios'
import getUrlBase from 'utils/getUrlBase'
import Storage from 'utils/storage'
import UserManager from 'utils/userManager'

const axiosInstance = axios.create()

axiosInstance.interceptors.request.use(
  async config => {
    const tokenRaw = localStorage.getItem('instabov_token')
    const token = tokenRaw ? JSON.parse(tokenRaw) : null

    const url = config.url || ''
    const isAbsoluteUrl = /^https?:\/\//i.test(url)

    // flag interna pra não injetar auth (use em chamadas externas)
    const skipAuth =
      config.headers?.['x-skip-auth'] === '1' || config.headers?.['x-skip-auth'] === 1

    // SEMPRE mesclar headers (não sobrescrever!)
    config.headers = {
      ...(config.headers || {}),
      'accept-language':
        config.headers?.['accept-language'] ?? UserManager.get('locale') ?? 'pt-BR',
    }

    // Se a URL for relativa (API do seu backend), seta baseURL e injeta token (se não estiver skip)
    if (!isAbsoluteUrl) {
      config.baseURL = process.env.REACT_APP_API_URL

      if (token && !skipAuth) {
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${token}`,
        }
      }
    }

    // remove flag interna antes de enviar
    if (config.headers?.['x-skip-auth']) {
      delete config.headers['x-skip-auth']
    }

    return config
  },
  error => Promise.reject(error),
)

axiosInstance.interceptors.response.use(
  response => {
    response.code = 200
    response.status = 'success'
    return response
  },
  error => {
    const status = error?.response?.status

    switch (status) {
      case 401: {
        Storage.clear()
        window.location.replace('/')
        return Promise.reject(error?.response)
      }

      case 400: {
        if (error?.response?.data?.message === 'user does not Root') {
          window.location.replace(getUrlBase())
          return Promise.reject(error?.response)
        }

        return Promise.reject({
          ...error?.response,
          data: error?.response?.data,
          code: status,
          status: 'error',
        })
      }

      default: {
        return Promise.reject({
          ...error?.response,
          data: error?.response?.data,
          code: status,
          status: 'error',
        })
      }
    }
  },
)

export default axiosInstance
